import React from 'react';
import classNameBind from 'classnames/bind';
import styles from '../Grid.module.css';

const bindClasses = classNameBind.bind(styles);

const Item = ({
  dataId,
  children,
  columns,
  rows,
  verticalAlignment,
  horizontalAlignment,
}) => (
  <div
    className={bindClasses(
      'item',
      {
        [`v-align-${verticalAlignment}`]: verticalAlignment,
        [`h-align-${horizontalAlignment}`]: horizontalAlignment,
      },
    )}
    style={{
      gridColumn: `span ${columns}`,
      msGridColumnSpan: columns,
      gridRow: `span ${rows}`,
      msGridRowSpan: rows,
    }}
    data-ppuc-id={dataId}
  >
    {children}
  </div>
);

Item.defaultProps = {
  rows: 1,
  columns: 1,
  dataId: 'GridItem',
};

export default Item;
